import React from 'react';
import NumberFormat from 'react-number-format';

function ParseNumberThousand({ field }: any) {
    return (
        <NumberFormat {...field} thousandSeparator={true} className={'form-know-you-item-input'} decimalScale={0} allowNegative={false}/>
    )
}

export default ParseNumberThousand;